{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valige üksus",
  "tableResizer": "Suuruse muutja",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
